import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/projectResourceSelect/styles.scss';export default {
  "container": "_container_1xy5k_1",
  "icon": "_icon_1xy5k_5",
  "list": "_list_1xy5k_11",
  "scrollContainer": "_scrollContainer_1xy5k_20"
};